/* Sundaygearus CRO helpers
   1) Khi cart drawer mở: ẩn mọi widget nổi của app (sales-pop, chat bubble, teaser)
      để không đè lên nút Check out. Widget trở lại khi đóng drawer.
   2) Nút scroll-to-top ẩn trên trang sản phẩm để không đè review / sticky ATC.
*/
(function () {
  var THEME_FIXED = ['CART-DRAWER', 'STICKY-HEADER', 'HEADER-DRAWER', 'MENU-DRAWER', 'CART-NOTIFICATION'];

  function isThemeNode(el) {
    if (THEME_FIXED.indexOf(el.tagName) !== -1) return true;
    if (el.closest && el.closest('cart-drawer, .shopify-section-header, .sticky-atc, .header, cart-notification, #shopify-section-header, .drawer')) return true;
    return false;
  }

  function floatingWidgets() {
    var out = [];
    var all = document.body.querySelectorAll('body > *, body > * > *');
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (isThemeNode(el)) continue;
      var cs = window.getComputedStyle(el);
      if (cs.position !== 'fixed') continue;
      var r = el.getBoundingClientRect();
      if (r.width === 0 || r.height === 0) continue;
      // bottom half of the viewport, or a side teaser
      var nearBottom = r.bottom > window.innerHeight * 0.5;
      var sideTab = r.width < 80 && r.height > 80;
      if (nearBottom || sideTab) out.push(el);
    }
    return out;
  }

  var hidden = [];
  function hideWidgets() {
    hidden = floatingWidgets();
    hidden.forEach(function (el) {
      el.setAttribute('data-sg-prev-vis', el.style.visibility || '');
      el.style.visibility = 'hidden';
      el.style.pointerEvents = 'none';
    });
  }
  function showWidgets() {
    hidden.forEach(function (el) {
      el.style.visibility = el.getAttribute('data-sg-prev-vis') || '';
      el.style.pointerEvents = '';
      el.removeAttribute('data-sg-prev-vis');
    });
    hidden = [];
  }

  function watchDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var wasActive = drawer.classList.contains('active');
    var obs = new MutationObserver(function () {
      var active = drawer.classList.contains('active');
      if (active && !wasActive) setTimeout(hideWidgets, 120);
      if (!active && wasActive) showWidgets();
      wasActive = active;
    });
    obs.observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchDrawer);
  else watchDrawer();
})();
